import { PageModuleDataToCreate } from "entities/pages/types";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";

type Params = {
  moduleData: PageModuleDataToCreate;
  brandId: string;
  settingId: string;
};

export const createSettingModule = async ({
  moduleData,
  brandId,
  settingId,
}: Params): Promise<void> => {
  const collectionRef = collection(
    db,
    `brands/${brandId}/settings/${settingId}/modules`,
  );
  await addDoc(collectionRef, {
    ...moduleData,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });
};
